import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { XAxisButton } from '@/common/dashboard/XAxisButton';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useMemo } from 'react';

export const McoInvTrendCard = ({ xAxisOptions, metricOptions }) => {
  const { formValues } = useForm();
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();

  const reqParam = useMemo(
    () => ({
      metric: formValues.metric,
      prodExpr: formValues.prodExpr,
      planCustExpr: formValues.planCustExpr,
      earnedPeriodExpr: formValues.earnedPeriodExpr,
      rbtPeriodExpr: formValues.rbtPeriodExpr,
      ctrtExpr: formValues.ctrtExpr,
      pbmExpr: formValues.pbmExpr,
      xAxis: formValues.xAxis,
    }),
    [
      formValues.metric,
      formValues.prodExpr,
      formValues.planCustExpr,
      formValues.earnedPeriodExpr,
      formValues.ctrtExpr,
      formValues.pbmExpr,
      formValues.rbtPeriodExpr,
      formValues.xAxis,
    ],
  );

  const navToMcoInvLineEntityList = (point) => {
    let entity = 'MCO_INV';
    rsrc
      .data('sc', 'MCO_INV_LINE_EXPR_DATA_PLUGIN', { ...reqParam, category: point.category, entity }, entity)
      .then((expr) => navigateTo('/sc/mco-inv-line', { mode: Mode.LIST, expr }));
  };

  const metric =
    metricOptions
      .filter((option) => formValues.metric?.includes(option.value))
      .map((option) => option.displayName)
      .join(' & ') || metricOptions[0].displayName;
  const xAxisLabel = xAxisOptions.find((option) => option.code === formValues.xAxis)?.displayName;
  return (
    <DashboardCard
      title={metric + ' by ' + xAxisLabel}
      description={'Displays the Indirect Sale Lines ' + metric + ' by ' + xAxisLabel}
      module="sc"
      plugin="MCO_INV_TREND_DATA_PLUGIN"
      reqParam={reqParam}
      buttons={<XAxisButton options={xAxisOptions} />}
    >
      {(data) => (
        <CartesianChart
          data={data}
          onClick={(point) => navToMcoInvLineEntityList(point)}
          rotateXLabels={false}
          legend="top"
          yLabel={'Amount in $'}
          allowNegative
        />
      )}
    </DashboardCard>
  );
};
